import "../css/style.scss"

// Our modules / classes
import ImgSlider from "./modules/ImgSlider"
import FeedbackSlider from "./modules/FeedbackSlider";
import BannerPopup from "./modules/BannerPopup";
import MobileMenu from "./modules/MobileMenu";
import QuantitySelector from "./modules/QuantitySelector";
// import HideWoocommerceMessage from "./modules/HideWoocommerceMessage";


// Instantiate a new object using our modules/classes
var imgSlider = new ImgSlider()
var feedbackSlider = new FeedbackSlider()
var bannerPopup = new BannerPopup()
var mobileMenu = new MobileMenu()
var quantitySelector = new QuantitySelector()
// var hideWoocommerceMessage = new HideWoocommerceMessage()


// Smooth Scroll
var scroll = new SmoothScroll('a[href*="#"]', {
  speed: 200,
  offset: 0
});

// Fix Transitions Bug on load
window.onload = function () {
  document.querySelector('body').classList.remove('preload');
}

// Zitae Swiper init
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
let swiper;
const zitateSwiper = function() {
  if (document.querySelector(".ww-zitate__container")) {
    // Actually init Swiper:
    swiper = new Swiper('.ww-zitate__container', {
      modules: [Navigation, Pagination],
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      hashNavigation: {
        watchState: true,
      },
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },  
      slidesPerView: 1,
      spaceBetween: 10,

      observer: true,  
      observeParents: true,

    });
  }
}
zitateSwiper();


// Destroy Zitate-Swiper on Desktop
const breakpoint = window.matchMedia( '(min-width:60rem)' );

const breakpointChecker = function() { 
   if ( breakpoint.matches === true ) {      
      if ( swiper !== undefined ) swiper.destroy( true, true ); 
      return;   
    } else if ( breakpoint.matches === false ) {   
      return zitateSwiper();   
    }
};
breakpoint.addListener(breakpointChecker);
breakpointChecker();


/* WooCommerce Functions */
  // Update Cart when changing Quantity
  jQuery( function( $ ) {
    let timeout;
    $('.woocommerce').on( 'change', 'input.qty', function(){
      if ( timeout !== undefined ) {
        clearTimeout( timeout );
      }
      timeout = setTimeout(function() {
        $("[name='update_cart']").trigger("click"); // trigger cart update
      }, 500 ); // 1 second delay, half a second (500) seems comfortable too
    });
  } );